import Form from 'forms/job/candidate_facing/components/form';
import Mounter from 'shared/utils/mounter';
import documentReady from 'document-ready';

documentReady(() => {
  new Mounter({
    CandidateFacing: {
      Form,
    },
  }).mountAll();
});
